/**
 * "Recent games" on somebody else's profile: the words a settled row wears. Pure, so it is testable without a
 * DOM; the compact row itself is `gameRowData` (game-row.ts) drawn by screens.ts (`gameRow`), the same row History uses.
 *
 * The status follows History's `matchStatus` word for word (WON, LOST, LOST · TIMED OUT, WON · FORFEIT, EXPIRED,
 * VOIDED · REFUNDED). The row has no forfeit flag: a forfeited round is a null score, so a loss with no score of
 * the player's own is "timed out" and a win with no score on the other side is "forfeit".
 */

import type { GameRow } from '@/net/api';

/** The status text and its tone (History's classes). */
export function gameStatus(r: GameRow): { text: string; cls: string } {
  switch (r.result) {
    case 'win':
      return r.opponent !== null && r.opponent.score === null ? { text: 'WON · FORFEIT', cls: 'won' } : { text: 'WON', cls: 'won' };
    case 'loss':
      return r.score === null ? { text: 'LOST · TIMED OUT', cls: 'lost' } : { text: 'LOST', cls: 'lost' };
    case 'voided':
      return { text: 'VOIDED · REFUNDED', cls: '' };
    case 'expired':
      return { text: 'EXPIRED', cls: '' };
    case 'playing':
      return { text: 'OPPONENT PLAYING', cls: 'taken' };
    default:
      return { text: 'WAITING', cls: 'open' };
  }
}
